import React from 'react'
import { styled } from '@mui/material/styles'
import { NavLink, NavLinkProps } from 'react-router'

import { Box, Drawer as MuiDrawer, ListItemButton, ListItemButtonProps, DrawerProps } from '@mui/material'

import Footer from './SidebarFooter'
import SidebarNav, { SidebarNavProps } from './SidebarNav'

const isDevEnv = import.meta.env.VITE_API_BASE_URL.includes('localhost')

const Drawer = styled(MuiDrawer)`
    border-right: 0;

    > div {
        border-right: 0;
    }
`

const Brand = styled(ListItemButton)<ListItemButtonProps & NavLinkProps>`
    font-size: ${(props) => props.theme.typography.h5.fontSize};
    font-weight: ${(props) => props.theme.typography.fontWeightMedium};
    color: ${(props) => props.theme.sidebar.header.color};
    background-color: ${(props) => props.theme.sidebar.header.background};
    font-family: ${(props) => props.theme.typography.fontFamily};
    min-height: 56px;
    padding-left: ${(props) => props.theme.spacing(6)};
    padding-right: ${(props) => props.theme.spacing(6)};
    justify-content: center;
    cursor: pointer;
    flex-grow: 0;

    ${(props) => props.theme.breakpoints.up('sm')} {
        min-height: 64px;
    }

    &:hover {
        background-color: ${(props) => props.theme.sidebar.header.background};
    }
`

const BrandIcon = styled('img')`
    margin-right: ${(props) => props.theme.spacing(2)};
    color: ${(props) => props.theme.sidebar.header.brand.color};
    fill: ${(props) => props.theme.sidebar.header.brand.color};
    ${isDevEnv
        ? 'filter: invert(42%) sepia(93%) saturate(1352%) hue-rotate(87deg) brightness(119%) contrast(119%);'
        : ''}

    width: 180px;
    background-size: 180px 32px;
`

interface SidebarProps extends DrawerProps {
    items: SidebarNavProps['items']
    showFooter?: boolean
}

const Sidebar = ({ items, showFooter = true, ...rest }: SidebarProps) => {
    return (
        <Drawer variant='permanent' {...rest}>
            <Brand component={NavLink} to='/'>
                <BrandIcon src='/static/img/brands/FL_white.svg' />
                {isDevEnv && <Box sx={{ position: 'absolute', bottom: -5, right: 20, color: 'white' }}>Dev</Box>}
            </Brand>
            <SidebarNav items={items} />
            {!!showFooter && <Footer />}
        </Drawer>
    )
}

export default Sidebar
